import React, { useEffect, useState } from "react";
import { ACTIONS } from "../../../../constants/Constants";
import { t } from "i18next";
import { Dropdown, TextField } from "@fluentui/react";
import CustomCheckBox from "../HeaderFileChecks/CustomCheckBox";
import { getSubModalityListNumbers } from "../../../../service/FirmServices";
import DropDown from "../../../../components/SVGComponents/Tools/DropDown";

const ConfigureSettings = (props) => {
  const [enablePrintDisclaimerText, setEnablePrintDisclaimerText] = useState(
    props.values.addPrintDisclaimer
  );
  const [enableAddendumDisclaimerText, setEnableAddendumDisclaimerText] =
    useState(props.values.addendumDisclaimerEnabled);

  const [subModalityListNumbers, setSubModalityListNumbers] = useState([]);

  useEffect(()=>{
    if(props.action == "EDIT"){
      fetchSubModalityListNumbers();
    }
  },[props.action])

  const fetchSubModalityListNumbers = async () => {
    const response = await getSubModalityListNumbers();
    console.log(response)
    if (response.status === 200) {
      let mdl = [];
              response.data.data.map((listnum) => {
        mdl.push({
          key: listnum,
          text: listnum,
        });
      });
      setSubModalityListNumbers(mdl);
    }
  };

  return (
    <>
      <div className="tab-section">
        <section
          className="sectionA"
          style={{ marginBottom: props.action === ACTIONS.EDIT ? "" : "1rem" }}
        >
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              padding: "0px 0px",
              marginBottom: "20px",
            }}
          >
            {t("hospital.configure-settings")}
          </p>
        </section>
        {/* EDIT CONFIGURATION SETTINGS */}
        {props.action === ACTIONS.EDIT && props.firmType != 1 && (
          <>
            {/* ENABLE PRINT DISCLAIMER */}
            <div style={{ display: "flex", maxHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-print-disclaimer")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.addPrintDisclaimer}
                    onChangeCustom={() => {
                      setEnablePrintDisclaimerText(!enablePrintDisclaimerText);
                      props.values.addPrintDisclaimer =
                        !props.values.addPrintDisclaimer;
                    }}
                  />
                </div>
              </div>
            </div>
            {enablePrintDisclaimerText && (
              <div style={{ display: "flex" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.print-disclaimer-text")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value">
                  <div
                    style={{
                      marginTop: "5px",
                      marginLeft: "5px",
                    }}
                  >
                    <TextField
                      styles={{
                        root: {
                          width: "100%",
                        },
                      }}
                      name="printDisclaimerText"
                      placeholder={t("hospital.print-disclaimer-text")}
                      value={props.values.printDisclaimerText}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      multiline
                      autoAdjustHeight
                      errorMessage={
                        props.errorState?.printDisclaimerText?.error &&
                        props.errorState?.printDisclaimerText?.msg
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {/* ENTER ACCOUNT WARNING */}
            <div style={{ display: "flex", minHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.account-warning")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                  <TextField
                    name="accountWarning"
                    placeholder={t("hospital.account-warning")}
                    onChange={(e) => {
                      props.handleChange(e);
                    }}
                    value={props.values.accountWarning}
                    autoAdjustHeight
                    multiline
                    errorMessage={
                      props.errorState?.accountWarning?.error &&
                      props.errorState?.accountWarning?.msg
                    }
                  />
                </div>
              </div>
            </div>

            {/* MAX PRIORITY COUNT */}
            <div style={{ display: "flex", maxHeight: "90px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.max-priority-count")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                  <TextField
                    name="priorityCount"
                    onChange={(e) => {
                      props.handleChange(e);
                      if (
                        props.errorState.priorityCount.error != undefined ||
                        props.errorState.priorityCount.error != null
                      ) {
                        props.errorState.priorityCount.error = false;
                      }
                    }}
                    errorMessage={
                      (props.errorState?.priorityCount?.error &&
                        props.errorState?.priorityCount?.msg) ||
                      props.firmGlobalErrorState?.priorityCount
                    }
                    value={props.values.priorityCount}
                    onBlur={props.handleBlur}
                    resizable={false}
                    type="number"
                  />
                </div>
              </div>
            </div>

             {/* SHOW PRIORS STUDIES */}
             <div style={{ display: "flex", maxHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-show-priors-studies")}
                </p>
              </div>
              <div id="show-priors-studies-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.showPriorsStudies}
                    onChangeCustom={() => {
                      props.values.showPriorsStudies =
                        !props.values.showPriorsStudies;
                    }}
                  />
                </div>
              </div>
            </div>

            {/* branch code */}
            {props.values.isMinimalAccount === 1 && (
                <>
                  <div style={{ display: "flex", maxHeight: "90px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.sub_modality_list_number")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <Dropdown
                          selectedKey={
                            props.values.selectedSubModalityListNumber
                          }
                          placeholder="Select Sub Modality List Number"
                          options={[...subModalityListNumbers]}
                          calloutProps={{ doNotLayer: true }}
                          onChange={(e, option) => {
                            props.values.selectedSubModalityListNumber =
                              option.key;
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", maxHeight: "90px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.branch-code")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <TextField
                          name="branchCode"
                          onChange={(e) => {
                            props.handleChange(e);
                          }}
                          errorMessage={props.firmGlobalErrorState?.branchCode}
                          value={props.values.branchCode}
                          onBlur={props.handleBlur}
                          resizable={false}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

            {/* show MS Word
            { (
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-ms-word")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.showWord}
                      onChangeCustom={() => {
                        props.values.showWord = !props.values.showWord;
                      }}
                    />
                  </div>
                </div>
              </div>
            )} */}
          </>
        )}
        {/* VIEW CONFIGURATION SETTINGS */}
        {(props.action === ACTIONS.VIEW || props.firmType == 1) && (
          <>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-print-disclaimer")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.addPrintDisclaimer ? "Yes" : "No"}</div>
                </div>
              </div>
              {enablePrintDisclaimerText && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                    <div className="form-heading">Print Disclaimer</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div>
                      {props.values.printDisclaimerText
                        ? props.values.printDisclaimerText
                        : "0"}
                    </div>
                  </div>
                </div>
              )}
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.account-warning")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.accountWarning
                      ? props.values.accountWarning
                      : "-"}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.max-priority-count")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.priorityCount
                      ? props.values.priorityCount
                      : "-"}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-show-priors-studies")}
                  </div>
                </div>
                <div id="show-priors-studies-value" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.showPriorsStudies ? "Yes" : "No"}</div>
                </div>
            </div>
              {props.values.isMinimalAccount === 1 && (
                  <>
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <div className="form-heading">
                          {t("hospital.sub_modality_list_number")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                        <div>
                          {props.values.selectedSubModalityListNumber
                            ? props.values.selectedSubModalityListNumber
                            : "-"}
                        </div>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <div className="form-heading">
                          {t("hospital.branch-code")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                        <div>
                          {props.values.branchCode
                            ? props.values.branchCode
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {props.firmType === 1 && (
                <>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <div className="form-heading">
                        {t("hospital.enable-addendum-disclaimer")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
                      <div>
                        {props.values.addendumDisclaimerEnabled ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                  {!!enableAddendumDisclaimerText && (
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3">
                        <div className="form-heading">
                          {t("hospital.addendum-disclaimer-text")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl8">
                        <div>
                          {props.values.addendumDisclaimerText
                            ? props.values.addendumDisclaimerText
                            : ""}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* { (

              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-ms-word")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.showWord ? "Yes" : "No"}</div>
                </div>
              </div>
              )} */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ConfigureSettings;